import { ModalHTMLElement } from './modal';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const YT: any;
type YTPlayer = {[key: string]: any};
/* eslint-enable @typescript-eslint/no-explicit-any */

export default function initYoutubePlayers() : void {
    const $players = document.querySelectorAll<HTMLElement>('.youtube-player');

    $players.forEach($player => {
        new YoutubePlayer($player);
    });
}

/**
 * Replace <div class="youtube-player" data-url="https://www.youtube.com/watch?v=XXXX"></div>
 * By the Youtube player
 */
class YoutubePlayer {
    $youtubePlayer: YTPlayer|null;
    $modalContaining: ModalHTMLElement|null;

    constructor($player: HTMLElement) {
        document.addEventListener('youtube-iframe-api-ready', () => {
            this.init($player);
        });

        // Register the modal containing the player if there is one
        this.$modalContaining = $player.closest('.modal');
    }

    /**
     * Initialize the Youtube player when he is ready
     * 
     * @param {HTMLElement} $player
     * 
     * @return {void}
     */
    init($player: HTMLElement) : void {
        const youtubeUrl = $player.dataset.url;

        // Find the video ID from URL
        let videoId = youtubeUrl.split('v=')[1] ?? null;
        if (!videoId) {
            return;
        }
        const ampersandPosition = videoId.indexOf('&');
        if (ampersandPosition !== -1) {
            videoId = videoId.substring(0, ampersandPosition);
        }

        // Create the iframe
        this.$youtubePlayer = new YT.Player($player, {
            videoId,
            host: 'https://www.youtube-nocookie.com',
            events: {
                onReady: (evt) => {
                    // Pause the video when the modal containing the player is closed
                    if (this.$modalContaining) {
                        this.$modalContaining.on('close', () => {
                            evt.target.pauseVideo();
                        });
                    }
                },
                onStateChange: (evt) => {
                    // Open the modal containing the player when the video is played
                    if (this.$modalContaining && evt.data === YT.PlayerState.PLAYING) {
                        this.$modalContaining.open();
                    }
                },
            },
        });
    }
}
